/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';

/*Import Requisição API*/
import api from '../../../../api';
import { useToast } from '../../../../context/ToastContext';

export default function CadastrarCategoria() {
    const [usuario_id, setIdUsuario] = useState(null);
    const [categorias, setCategorias] = useState([]);
    const fetchingRef = useRef(false);
    const [nome, setNome] = useState('');
    const [descricao, setDescricao] = useState('');
    const [idCategoriaPai, setIdCategoriaPai] = useState('');
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [idCategoriaParaExcluir, setIdCategoriaParaExcluir] = useState(null);

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    /* Dialog de exclusão de funcionário */
    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const abrirModalExcluir = (id_categoria) => {
        setIdCategoriaParaExcluir(id_categoria);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const fecharModal = () => {
        setModalAberto(false);
        caixaDeDialogo.current?.close();
        setIdCategoriaParaExcluir(null);
    };

    const confirmarExcluirCategoria = async () => {
        try {
            await api.delete(`/categoria/${idCategoriaParaExcluir}`, {
                data: { usuario_id }
            });
            fecharModal();
            navigate('/menu/categoria');
        } catch (error) {
            fecharModal();
            setTexto(error.response?.data?.message || 'Erro ao excluir categoria.')
            abrirModalAviso();
        }
    };

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    useEffect(() => {
        // Evita chamadas concorrentes / repetidas enquanto uma busca está em andamento
        if (fetchingRef.current) return;
        fetchingRef.current = true;

        // Rodar apenas uma vez ao montar: evitar loop quando o backend retorna []
        const buscarCategorias = async () => {
            try {
                console.log('Chamando o backend para buscar categorias...');
                const response = await api.get('/categoriashierarquicas');
                console.log('Resposta do backend:', response);
                if (response.data.success && Array.isArray(response.data.categorias) && response.data.categorias.length > 0) {
                    setCategorias(response.data.categorias);
                    console.log('Categorias listadas com sucesso:', response.data.categorias);
                } else {
                    console.error('Nenhuma categoria encontrada ou erro no backend:', response.data.message);
                }
            } catch (error) {
                console.error('Erro ao buscar categorias:', error);
            }
        };

        buscarCategorias().finally(() => { fetchingRef.current = false; });
    }, []);

    const enviarCadastroCategoria = async (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);

        console.log('Dados enviados:', {
            nome,
            descricao,
            id_categoria_pai: idCategoriaPai || null,
        });

        try {
            const response = await api.post('/categorias', {
                nome,
                descricao,
                id_categoria_pai: idCategoriaPai || null,
            });

            if (response.data.success) {
                navigate('/menu/categorias')
                showToast('Categoria criada com sucesso!', 'success');
            }
        } catch (error) {
            showToast('Erro ao criar Categoria!', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="container-principal-cadastro-categoria">

            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse categoria?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarExcluirCategoria}>
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModal}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <dialog id='CaixaDeDialogoAviso' className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>{texto}</p>
                        <button id='botao' onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className="conteudo-cadastro-categoria">
                    <div className="titulo-perfil">
                        <h1><span>Categorias</span> &gt; Cadastro de Categoria</h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Salvando...</h2>
                        </div>
                    ) : (
                    <div className='perfil-cadastro-categoria'>
                        <h2>Digite os dados da categoria</h2>
                        <form className="form-cadastro-categoria" onSubmit={enviarCadastroCategoria}>
                            <label>Nome da Categoria: <span className='span-obrigatorio'>*</span></label>
                            <div className='input-nome'>
                                <input
                                    type="text"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o nome da categoria"
                                />
                            </div>

                            <label>Descrição (opcional):</label>
                            <div className='input-descricao'>
                                <textarea
                                    value={descricao}
                                    onChange={(e) => setDescricao(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite a descrição da categoria"
                                />
                            </div>


                            <label>Categoria Pai (opcional):</label>
                            <div className='input-categoriaPai'>
                                <select
                                    value={idCategoriaPai}
                                    onChange={(e) => setIdCategoriaPai(e.target.value)} 
                                >
                                    <option value="">Categoria Raiz</option>
                                    {categorias.map((categoria) => (
                                        <option key={categoria.id} value={categoria.id}>
                                            {categoria.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <button className='bnt-cadastro-categoria' type="submit">Cadastrar Categoria</button>
                        </form>
                    </div>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}